import React, { useState, useRef } from "react";
import { string, func, object } from "prop-types";
import DateRangePicker from "react-daterange-picker";
import { connect } from "react-redux";
import get from "lodash/get";

import TextField from "../TextField";

import { useOuterClickNotifier, getBanglaDate, getEngDate } from "../../utils/utils";

import "react-daterange-picker/src/css/react-calendar.scss";
import "./datePicker.m.css";

require("moment/locale/bn");

const DatePicker = ({ placeholder, dateSelected, date, publisherAttributes }) => {
  const innerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const dateSelect = value => {
    setIsOpen(false);
    dateSelected(value);
  };

  const openDatePicker = () => {
    !isOpen && setIsOpen(true);
  };

  const closeDatePicker = () => {
    isOpen && setIsOpen(false);
  };

  useOuterClickNotifier(closeDatePicker, innerRef);

  return (
    <div>
      <div styleName="date-wrapper" className="date-wrapper" ref={innerRef}>
        <TextField
          inputType="type2"
          value={
            date
              ? publisherAttributes.lang === "bn"
                ? getBanglaDate(new Date(date))
                : getEngDate(new Date(date), "monthname")
              : null
          }
          placeholder={placeholder}
          readOnly
          onClick={openDatePicker}
        />

        {isOpen ? (
          <div styleName="date-picker-view">
            <DateRangePicker
              value={date}
              onSelect={value => dateSelect(value, "from")}
              selectionType="single"
              locale={publisherAttributes.lang === "bn" ? "bn" : "en"}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

DatePicker.propTypes = {
  placeholder: string.isRequired,
  dateSelected: func.isRequired,
  date: object,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(DatePicker);
